import React from "react";
import { FaLinkedin } from "react-icons/fa";
import { MdWork } from "react-icons/md";
import profile from "../../assets/img/myprofilebgless.png";
import { useForm, ValidationError } from "@formspree/react";
import contactGif from '../../assets/img/contact-gif.gif'
import { SiFiverr } from "react-icons/si";
import { FaGithub } from "react-icons/fa";

const Form = () => {
    const [state, handleSubmit] = useForm("mdayrvov");
    
    return (
        <div className="  pb-24 md:pt-5 relative top-[20px] rounded-t-3xl w-full flex flex-col items-center justify-center text-white">
            <div className="w-[97%] xl:w-[80%] xl:gap-x-10 flex items-center justify-between">
                {/* left */}
                {/* Form */}
                <form onSubmit={handleSubmit} className="w-full">
                <div
                    className="flex flex-col  justify-center py-5 px-7 rounded-xl bg-[#1d1d1d] shadow-black shadow-lg gap-y-3 lg:gap-y-4 w-full  md:w-[95%] lg:w-[90%] xl:w-[580px] "
                    data-aos="flip-right"
                    data-aos-offset="100"
                    data-aos-delay="600"
                >
                    <div className='font-bold text-[20px] flex items-center justify-center w-full text-center'><h6>Contact Me</h6> <img src={contactGif} alt="contact gif" className='h-9'/></div>
                        <div className="flex-col flex gap-x-2 items-start justify-center">
                        <label className="font-semibold text-[16px] mb-0">Name</label>
                        <input required placeholder="Enter Your Name" name="name" type="text" className=" px-2 w-full py-[5px] rounded-sm outline-none text-[#525252]" />
                        <ValidationError prefix="Name" field="name" errors={state.errors} className="mt-1 text-xs text-red-300" />
                        </div>
                        <div className="flex-col flex gap-x-2 items-start justify-center">
                        <label className="font-semibold text-[16px] mb-0">Email</label>
                        <input required placeholder="Enter Your Email" name="email" type="email" className=" px-2 w-full py-[5px] rounded-sm outline-none text-[#525252]" />
                        <ValidationError prefix="Email" field="email" errors={state.errors} className="mt-1 text-xs text-red-300" />
                        </div>
                        <div className="flex-col flex gap-x-2 items-start justify-center">
                        <label className="font-semibold text-[16px] mb-0">Message</label>
                        <textarea required placeholder="How can I help you?" name="message" type="textarea" className=" px-2 w-full py-[5px] rounded-sm outline-none min-h-[100px] text-[#525252]" />
                        <ValidationError prefix="Message" field="message" errors={state.errors} className="mt-1 text-xs text-red-300" />
                        </div>
                        <div className="flex w-full justify-end">
                            <button disabled={state.submitting} type="submit" className="py-1 px-3 text-black bg-white rounded-md hover:scale-110 transition-all duration-100 disabled:opacity-60 disabled:cursor-not-allowed disabled:hover:scale-100" title="Submit your message">{state.submitting ? "Sending..." : "Submit"}</button>
                        </div>
                        {state.succeeded ? (
                            <p className="text-sm text-green-300">Thanks! Your message has been sent successfully.</p>
                        ) : null}
                        <ValidationError errors={state.errors} className="text-xs text-red-300" />
                        <div>
                            <div className="font-bold text-[20px] flex items-center gap-x-2">
                                <h6>Platforms</h6>{" "}
                                <MdWork size={20} className="text-[#ffffff]" />
                            </div>
                            <div className="flex items-center mt-2 gap-x-3">
                              <a href="https://www.linkedin.com/in/gulfam-haider-861016291/" target="_blank" rel="noopener noreferrer"><FaLinkedin size={33} className='text-[#26ADF6]'  title='LinkedIn Profile'/></a>
                <a href="https://github.com/Gulfam619" target="_blank" rel="noopener noreferrer"><div  className='bg-black rounded-full p-1 '  title='Fiverr Profile'><FaGithub    size={23} className='text-white'/></div></a>
                <a href="https://www.fiverr.com/gulfam207" target="_blank" rel="noopener noreferrer"><div  className='bg-[#1f6e38] rounded-full p-1 '  title='Fiverr Profile'><SiFiverr     size={23} className='text-white'/></div></a>
          
                            </div>
                        </div>
                </div>
                    </form>

                {/* right */}
                <img
                    src={profile}
                    alt=""
                    className="hidden md:block md:w-[42%] lg:w-[450px] xl:w-[480px]  "
                    data-aos="fade-left"
                    data-aos-offset="100"
                    data-aos-delay="100"
                />
            </div>
        </div>
    );
};

export default Form;
